(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row-1x2.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row-1x2.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const formatDate = svs.components.poolBetting.utils.formatDate;
const ParticipantsNames = svs.components.lbUi.participants.ParticipantsNames;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const Outcomes1x2 = svs.components.poolBetting.printableCoupon.Outcomes1x2;
const PrintableCouponRow1x2 = _ref => {
  let drawEvent = _ref.drawEvent,
    _ref$hasMSign = _ref.hasMSign,
    hasMSign = _ref$hasMSign === void 0 ? false : _ref$hasMSign,
    participants = _ref.participants,
    signs = _ref.signs,
    uSign = _ref.uSign;
  const sportEvent = useSelector(state => selectSportEvent(state, drawEvent.matchId));
  const matchStart = sportEvent.matchStart;
  return React.createElement("div", {
    className: "pb_print_coupon__row",
    key: drawEvent.eventNumber
  }, React.createElement("div", {
    className: "event__number"
  }, drawEvent.eventNumber), React.createElement("div", {
    className: "event__participants"
  }, React.createElement(ParticipantsNames, {
    awayParticipant: participants[1],
    homeParticipant: participants[0],
    nameSize: DescriptionSize.Full
  })), React.createElement("div", {
    className: "event__match_start"
  }, formatDate(matchStart, {
    showDayOfWeek: true
  })), React.createElement("div", {
    className: "event__m_sign"
  }, hasMSign && 'M'), React.createElement("div", {
    className: "event__outcomes"
  }, React.createElement(Outcomes1x2, {
    className: "event__outcomes__1x2",
    signs: signs,
    uSign: uSign
  })));
};
setGlobal('svs.components.poolBetting.printableCouponRow.PrintableCouponRow1x2', PrintableCouponRow1x2);

 })(window);